export default {
  namespaced: true,

  state: {
    filters: {}
  },

  getters: {
    filters: state => state.filters,
  },

  mutations: {
    SET_HEADER_FILTER(state, value) {
      state.filters = { ...value };
    },

    CLEAR_HEADER_FILTER(state) {
      state.filters = {};
    },
  },

  actions: {
    setHeaderFilter({ commit }, value) {
      commit('SET_HEADER_FILTER', value);
    },

    clearHeaderFilter({ commit }) {
      commit('CLEAR_HEADER_FILTER');
    },
  },
};
